import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { AuthProvider } from './auth/AuthContext';
import { store } from './store/store';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import DashboardLayout from './components/Layout/DashboardLayout';
import Dashboard from './pages/Dashboard';
import AdminUsers from './pages/AdminUsers';
import Feedback from './pages/Feedback';
import Roles from './pages/Roles';
import Prompts from './pages/Prompts';
import Subscriptions from './pages/Subscriptions';
import Settings from './pages/Settings';
import Statistics from './pages/Statistics';
import Login from './pages/Login';
import KeywordsAdmin from './pages/KeywordsAdmin';
import Registrations from './pages/Registrations';
import Users from './pages/Users';
import CorrectionHistory from './pages/CorrectionHistory';

/**
 * QualiteeMed.ai Admin Dashboard Application
 * Healthcare platform administration interface
 */
const App = () => {
  return (
    <Provider store={store}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Dashboard />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin-users"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <AdminUsers />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/feedback"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Feedback />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/roles"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Roles />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/prompts"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Prompts />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscriptions"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Subscriptions />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Settings />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/statistics"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Statistics />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/keywords-admin"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <KeywordsAdmin />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/registrations"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Registrations />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Users />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/correction-history"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <CorrectionHistory />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </Provider>
  );
};

export default App; 